module.exports = __webpack_public_path__ + "img/csr_swiper_03_02.2842d4b9.jpg";